export const LOAN_TYPES = {
  BANK: { label: "Банкны зээл", color: "blue" },
  NBFI: { label: "ББСБ-ын зээл", color: "purple" },
};

export const LOAN_CATEGORIES = {
  CONSUMER: { label: "Хэрэглээний" },
  SALARY: { label: "Цалин" },
  HOUSEHOLD: { label: "Өрхийн" },
  HERDER: { label: "Малчин" },
  CAR: { label: "Машин" },
  LEASING: { label: "Лизинг" },
  PENSION: { label: "Тэтгэвэр" },
  STUDENT: { label: "Оюутан" },
  DEPOSIT_BACKED: { label: "Хадгаламж барьцаалсан" },
  REAL_ESTATE_BACKED: { label: "Үл хөдлөх барьцаалсан" },
  QUICK_LOAN: { label: "Шуурхай зээл" },
  DIGITAL: { label: "Дижитал" },
  OTHER: { label: "Бусад" },
};

// Derived — автоматаар үүснэ
export const LOAN_TYPE_OPTIONS = Object.entries(LOAN_TYPES).map(([key, v]) => ({
  value: key,
  label: v.label,
}));
export const LOAN_TYPE_LABEL = (type) => LOAN_TYPES[type]?.label ?? type;
export const LOAN_TYPE_COLOR = (type) => LOAN_TYPES[type]?.color ?? "default";

export const LOAN_CATEGORY_OPTIONS = Object.entries(LOAN_CATEGORIES).map(
  ([key, v]) => ({ value: key, label: v.label }),
);
export const LOAN_CATEGORY_LABEL = (cat) => LOAN_CATEGORIES[cat]?.label ?? cat;
